import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table } from 'cat-ecommerce-alloy';
import { getCustomRenderers } from '../utils';
import { TABLE_ITEM_PADDING } from '../constants';

const CartImportSummaryTable = ({ totalItemsAdded, totalItemsRequested }) => {
  const { t } = useTranslation();
  const schema = [
    {
      id: 'itemsSubmitted',
      label: `${t('MO_ITEMS')} ${t('MO_OrderStatus_I')}`,
      width: '50%',
      padding: TABLE_ITEM_PADDING,
      hideOnMobile: true
    },
    {
      id: 'itemsAdded',
      label: `${t('MO_ITEMS')} ${t('ADDED')}`,
      width: '50%',
      padding: TABLE_ITEM_PADDING,
      hideOnMobile: true
    },
    {
      id: 'itemsSummaryMobileCell',
      width: '90%',
      submittedLabel: `${t('MO_ITEMS')} ${t('MO_OrderStatus_I')}`,
      addedLabel: `${t('MO_ITEMS')} ${t('ADDED')}`,
      hideOnDesktop: true
    }
  ];
  const data = [
    {
      itemsSubmitted: totalItemsRequested,
      itemsAdded: totalItemsAdded
    }
  ];
  return (
    <div className="mb-4">
      <Table
        schema={schema}
        data={data}
        customRenderers={getCustomRenderers()}
      />
    </div>
  );
};

export default CartImportSummaryTable;

CartImportSummaryTable.propTypes = {
  totalItemsAdded: PropTypes.number,
  totalItemsRequested: PropTypes.number
};
